import React from "react";

// Shared exceptional-state presentation for the six Agent Toolbar/Main
// Card tool panels (WORKSPACE-AUDIT-007 §13 item 4). Rendered instead of a
// panel's normal content whenever its projection's resolved status is not
// "ok" — missing, restricted, stale, conflicting, reconciliation-required,
// pending, unknown, or cross-Account-mismatched evidence never falls
// through to the normal render path, and no panel invents placeholder
// content to fill the gap.
const STATUS_COPY = Object.freeze({
  missing: "No information is currently available for this tool.",
  restricted: "This information is restricted and cannot be displayed.",
  stale: "This information is no longer current and cannot be safely displayed.",
  conflicting: "Conflicting information was received and cannot be safely displayed.",
  "reconciliation-required": "This information requires reconciliation before it can be displayed.",
  pending: "This information is still being confirmed.",
  "cross-account-mismatch": "This information belongs to a different Account and cannot be displayed.",
  unknown: "This information is currently unknown and cannot be safely displayed.",
});

export default function ToolProjectionNotice({ status, reason, testIdPrefix }) {
  const message = STATUS_COPY[status] || STATUS_COPY.unknown;
  return (
    <div
      className="flex flex-col gap-1 rounded-lg border border-white/10 bg-white/5 p-3 text-xs text-slate-400"
      data-testid={`${testIdPrefix}-projection-${status}`}
      role="status"
    >
      <p className="font-medium text-slate-300">{message}</p>
      {reason ? <p className="text-[11px] text-slate-500">{reason}</p> : null}
    </div>
  );
}
